var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{
      extendTreeType:_vm.$route.query.IS_TREE,
    },"option":{
      extendTreeType:_vm.$route.query.IS_TREE,
    },"colObj":{
      opId:"127",
      name:"代码管理",
      parentId:"TABLE_NAME",
      parentName:"代码表管理",
      parentPath:"/system/codeTable",
      dataClass:2,
      isTree:_vm.isTree,
      col:[],
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }